import { render, staticRenderFns } from "./submitManualBillApplication.vue?vue&type=template&id=12ad4954"
import script from "./submitManualBillApplication.vue?vue&type=script&lang=js"
export * from "./submitManualBillApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports